// Display helpers: localized enum labels + money with FCFA approximation (feedback #4/#6).

// Translate a data enum (sector, stage, funding type…) via the i18n `enums` maps,
// falling back to the raw value for unknown/legacy entries.
export const tEnum = (t, group, value) => (value ? t(`enums.${group}.${value}`, value) : "");

// Text that may be bilingual ({fr, en}) or a plain legacy string. Falls back to
// the other language when the requested one is empty, so a founder who writes
// in one language still gets a complete listing for every visitor.
export const pickLang = (v, lang) => {
  if (!v) return "";
  if (typeof v === "string") return v;
  const other = lang === "fr" ? "en" : "fr";
  return (v[lang] || "").trim() ? v[lang] : (v[other] || "");
};

// A URL somebody typed into a form. Without a scheme the browser reads
// "www.example.org" as a path and sends the visitor to a 404 on our own site, so
// the link is completed rather than trusted. Anything already carrying a scheme
// (http, https, mailto) is left alone, and javascript: is refused outright.
export const externalUrl = (u) => {
  const s = (u || "").trim();
  if (!s) return "";
  if (/^javascript:/i.test(s)) return "";
  return /^[a-z][a-z0-9+.-]*:/i.test(s) || s.startsWith("//") ? s : `https://${s}`;
};

// Public address of a startup: the readable slug when it has one, else the id
// (an older payload without a slug still links somewhere that works).
export const startupPath = (s) => `/startups/${s?.slug || s?.startup_id}`;

// Le nom d'un réseau tel qu'il l'écrit lui-même : une capitale au mauvais
// endroit se remarque plus qu'on ne croit.
const SOCIAL_NAMES = { linkedin: "LinkedIn", facebook: "Facebook", instagram: "Instagram", youtube: "YouTube", whatsapp: "WhatsApp", twitter: "X" };
export const socialName = (k) => SOCIAL_NAMES[k] || k;

// L'adresse complète d'un chemin interne : depuis une liste, le lien à
// partager n'est pas celui de la page où l'on se trouve.
export const absoluteUrl = (path) =>
  (typeof window === "undefined" ? "https://startupcafe.bf" : window.location.origin) + path;
